export default {
  logoTitle: 'Seller Center',
  home: 'Home',
  loginOut: 'log out',
  footer: 'Kilimall e-Commerce Cloud ',
  // ---------
  subMenuListName2: 'Warehouse settings',
  subMenuListName3: 'Add Product',
  subMenuListName4: 'Manage Products',
  subMenuListName5: 'Customized Categories',
  subMenuListName6: 'Batch import product',
  subMenuListName7: 'Product Reviews',
  subMenuListName8: 'Batch Products Expansion',
  subMenuListName9: 'Manage Orders',
  subMenuListName10: 'Dispatch Orders',
  subMenuListName11: 'FBM Settings',
  subMenuListName12: 'Manage My Stores',
  subMenuListName13: 'Settings',
  subMenuListName14: 'Manage Main Account',
  subMenuListName15: 'Manage Staff Accounts',
  subMenuListName16: 'Developer Information',
  subMenuListName17: 'Manage Voucher Templates',
  subMenuListName18: 'Manage Voucher Batches',
  subMenuListName19: 'Manage Vouchers',
  subMenuListName20: 'Flash-Sale Application',
  subMenuListName21: 'Flash-Sale Products',
  subMenuListName22: 'Apply for TD',
  subMenuListName23: 'Limited-Time Deal Management',
  subMenuListName24: 'Talking Messages',
  subMenuListName25: 'Manage Platform Coin Plans',
  subMenuListName26: 'Product Recommendations',
  subMenuListName27: 'Cross-Store Spend & Save Management',
  subMenuListName28: 'Manage After-sales',
  subMenuListName29: 'Manage Settlements (Beta)',
  subMenuListName30: 'Apply for Promotions',
  subMenuListName31: 'Group-Buy Products',
  subMenuListName32: 'Campaign Product Management',
  subMenuListName33: 'Platform Notifications',
  subMenuListName36: 'Violation Penalty Record', // S331
  subMenuListName37: 'Platform Logistics Account',
  shopNews39: 'Platform Announcement',
  // applyUseWarehouseTitle: 'Apply For Use Of Warehouses', // 申请仓库授权
  applyUseWarehouseTitle: 'Manage Warehouse Authorization', // 申请仓库授权
  subMenuListName44: 'Manage FBK Inventory',
  subMenuListName45: 'Product-level Delivery Fee',
  subMenuListName46: 'Store-level Delivery Fee',
  subMenuListName47: 'Customer Chats',
  subMenuListName51: 'Gift Settings',
  subMenuListName52: 'Manage Gifts',
  scrapListName: 'Scrap Application Records',
  returnListName: 'Warehouse Return Application Records',
  // -----------
  menu2: 'Product',
  menu3: 'Order',
  menu4: 'Service',
  menu5: 'Restocking',
  menu6: 'Promotion',
  insights: 'Insights',
  menu8: 'Finance',
  menu9: 'Store',
  menu10: 'Seller Settings',
  menu11: 'Promotions',
  menu12: '物流与仓库',
  //
  userName: 'Unkown Name',
  logisticsHeadAccount: 'Prepaid Logistics Account',
  logisticsCostSheets: 'Logistics Billing Sheets',
  restockInvitations: 'Restocking Invitations',
  reviewList: 'Product Reviews',
  helpCenter: 'Help Center',
  sellerUniversity: 'Seller University',
  loginNewSeller: 'Go to old seller center',
  transactionOrderNo: 'Sale Order No',
  logisticsOrderNo: 'Waybill No',
  countryCode: 'Country Code',
  storeId: 'Store ID',
  feeType: 'Fee Type',
  billingInfo: 'Billing Info',
  billingAmount: 'Billing Amount',
  billingRate: 'Exchange rate',
  billingTime: 'Billing Time',
  paymentAmount: 'Payment Amount',
  remark: 'Remark',
  paymentStatus: 'Payment Status',
  paymentTime: 'Payment Time',
  shippingFee: 'Shipping Fee',
  operatingFee: 'Operating Fee',
  packingService: 'Packing Service Fee',
  adjustment: 'Adjustment compensation',
  noDeductionNow: '暂不扣费',
  adjustmentDeduction: 'Adjustment and deduction',
  feedbackAndComplaint: 'Feedback and Complaints',
  sellerApp: 'Seller App',
  downloadAppleApp: 'Download the Seller App to manage your store and orders anytime',
  directDownload: 'Direct download',
  downloadAppTip: 'Downloading, please wait.'
}
